import { useEffect, useState, useTransition } from "react";
import { useLocation } from "react-router-dom";
import { Button, Input, Modal, Select } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
// import { updateChatNotifications } from "apis/firebaseService";
import { handleLogout } from "utils/helpfulFunctions";
import { updateCurrentPath } from "store/dynamicData";
import ROUTES from "router/NewRoutes";

// assets
import logoutIcon from "assets/icons/sidebar/logout.svg";
import logo from "assets/images/new-logo.png";

// Icons components
// import SalesRequestsIcon from "./Icons/SalesRequestsIcon";
// import DealersChecksIcon from "./Icons/DealersChecksIcon";
// import ScrappersSalesRequestsIcon from "./Icons/ScrappersSalesRequestsIcon";
// import ItemsIcon from "./Icons/ItemsIcon";
// import AllOrdersIcon from "./Icons/AllOrdersIcon";
// import PendingOrdersIcon from "./Icons/PendingOrdersIcon";
// import TypesIcon from "./Icons/TypesIcon";
import AdminsIcon from "./Icons/AdminsIcon";
import StoresIcon from "./Icons/StoresIcon";
import SettingsIcon from "./Icons/SettingsIcon";
import RedeemPointsIcon from "./Icons/RedeemPointsIcon";
import CansSalesRequestsIcon from "./Icons/CansSalesRequestsIcon";
import SupplyingTypesIcon from "./Icons/SupplyingTypesIcon";
import DealersIcon from "./Icons/DealersIcon";
import AcceptedReportIcon from "./Icons/AcceptedReportIcon";
import HomeBannerIcon from "./Icons/HomeBannerIcon";
import SocialOrdersIcon from "./Icons/SocialOrdersIcon";
import CourierIcon from "./Icons/CourierIcon";
import CourierReportIcon from "./Icons/CourierReportIcon";
import GovernmentIcon from "./Icons/GovernmentIcon";
import CityIcon from "./Icons/CityIcon";
import DoDontImageIcon from "./Icons/DoDontImageIcon";
import StoreCategoriesIcon from "./Icons/StoreCategoriesIcon";
import StoreSubcategoriesIcon from "./Icons/StoreSubcategoriesIcon";
import StoreItemsIcon from "./Icons/StoreItemsIcon";
import NotificationIcon from "./Icons/NotificationIcon";
import PartnersIcon from "./Icons/PartnersIcon";
import DailyCouriersIcon from "./Icons/DailyCouriersIcon";
import MarketplaceBannerIcon from "./Icons/MarkeplaceBannerIcon";
import PartnershipIcon from "./Icons/PartnershipIcon";
import ChatIcon from "./Icons/ChatIcon";
import SalesRequestsReturnsIcon from "./Icons/SalesRequestsReturnsIcon";
import MerchantSalesRequestsIcon from "./Icons/MerchantSalesRequestsIcon";
import MerchantPeriodsIcon from "./Icons/MerchantPeriodsIcon";
import MerchantScrapTypesIcon from "./Icons/MerchantScrapTypesIcon";
import ScrappersChatIcon from "./Icons/ScrappersChatIcon";
import CourierDistrictsIcon from "./Icons/CourierDistrictsIcon";
import CommunityCategoriesIcon from "./Icons/CommunityCategories";
import CommunitySubCategoriesIcon from "./Icons/CommunitySubCategories";
import PendingPostsIcon from "./Icons/PendingPost";
import RejectedPostsIcon from "./Icons/RejectedPostsIcon";
import AcceptedPostsIcon from "./Icons/AcceptedPostsIcon";
import CashTransferIcon from "./Icons/CashTransferIcon";
import AdminPostsIcon from "./Icons/AdminPostsIcon";
// import InstallmentPlansIcon from "./Icons/InstallmentPlansIcon";
// import InstallmentRequestsIcon from "./Icons/InstallmentRequestsIcon";
// import InstalllmentPendingOrdersIcon from "./Icons/InstallmentPendingOrdersIcon";
// import CustomerPaymentDuesIcon from "./Icons/CustomerPaymentDuesIcon";
// import AdminPaymentDuesIcon from "./Icons/AdminPaymentDuesIcon";
// import InstallmentAcceptedOrdersIcon from "./Icons/InstallmentAcceptedOrdersIcon";
// import InstallmentStatisticsIcon from "./Icons/InstallmentStatisticsIcon";
import MerchantsIcon from "./Icons/MerchantsIcon";
import BuyersIcon from "./Icons/BuyersIcon";
import MerchantsOrdersIcons from "./Icons/MerchantsOrdersIcons";
import BuyersOrdersIcon from "./Icons/BuyersOrdersIcon";
import StockScrapTypesIcon from "./Icons/StockScrapTypesIcon";
import StockDailyCouriersIcon from "./Icons/StockDailyCouriersIcon";
import CourierTrackingIcon from "./Icons/CourierTrackingIcon";
import AttributeKeysIcon from "./Icons/AttributeKeysIcon";
import LinkingAttributesIcon from "./Icons/LinkingAttributeIcon";
import PostsAttributesIcon from "./Icons/PostsAttributesIcon";
import InitialsScrapBalanceIcon from "./Icons/InitialScrapBalanceIcon";

// components
import Tab from "./Tab";
import City from "modules/City";
import RatesIcons from "./Icons/RatesIcons";
import { useIsMobile } from "hooks/useIsMobile";
import { SearchOutlined } from "@ant-design/icons";
import { setShop } from "store/shopSlice";
import { useAuth } from "hooks/useAuth";

import QuestionIcon from "./Icons/QuestionIcon";
import QuestionCategoryIcon from "./Icons/QuestionCategoryIcon";
import MerchantBuyItemIcon from "./Icons/MerchantBuyItem";
import PendingMerchantIcon from "./Icons/PendingMerchant";
import MerchantBuyOrderIcon from "./Icons/MerchantBuyOrder";
import ScraptionCompanyIcon from "./Icons/ScraptionCompanyIcon";
import GulfCategory from "./Icons/GulfCategory";
import GulfSubCategory from "./Icons/GulfSubCategory";
import GulfProduct from "./Icons/GulfProduct";
import GulfDistrict from "./Icons/GulfDistrict";
import GulfGovernment from "./Icons/GulfGovernment";
import PendingCash from "./Icons/PendingCash";
import MerchantStore from "./Icons/MerchantStore";

const SideBar = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState("");
  const { authorization } = useSelector((state) => state?.auth);
  const { selectedShop, shopStores } = useSelector((state) => state.shop);
  const { forShop } = useAuth();
  // const { notifications: chatNotifications, greenScoutsNotifications } =
  //   useSelector((state) => state.chat);
  const dispatch = useDispatch();
  const location = useLocation();
  const adminRoles = authorization.roles;
  const environment = process.env.REACT_APP_NODE_ENV;
  const isMobile = useIsMobile();

  // environment: [1, 2] -->  1 = test and 2 = live
  // maximum existing id = 62
  const tabsData = [
    {
      id: 0,
      icon: <AdminsIcon />,
      name: "Admins",
      link: ROUTES.ADMINS,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 1,
      icon: <DealersIcon />,
      name: "Scrappers",
      link: ROUTES.DEALERS,
      roles: [1, 9, 11],
      environment: [1, 2],
    },
    {
      id: 2,
      icon: <CansSalesRequestsIcon />,
      name: "Scrap Sales Requests",
      link: ROUTES.SCRAP_SALES_REQUESTS,
      roles: [1, 9, 11, 12, 15],
      environment: [1, 2],
    },
    {
      id: 64,
      icon: <CansSalesRequestsIcon />,
      name: "Scrap Sales Requests UAE",
      link: ROUTES.SCRAP_SALES_REQUESTS_UAE,
      roles: [1, 9, 11, 12, 15],
      environment: [1, 2],
    },
    {
      id: 40,
      icon: <CashTransferIcon />,
      name: "Cash Transfer",
      link: ROUTES.CASH_TRANSFER,
      roles: [1, 9, 18],
      environment: [1, 2],
    },
    {
      id: 3,
      icon: <AcceptedReportIcon />,
      name: "Accepted Requests Report",
      link: ROUTES.ACCEPTED_REQUESTS_REPORT,
      roles: [1, 9, 11],
      environment: [1, 2],
    },
    {
      id: 306,
      icon: <SocialOrdersIcon />,
      name: "Pending Scrap Request",
      link: ROUTES.PENDING_SCRAP_REQUEST,
      roles: [1, 9, 11],
      environment: [1, 2],
    },
    {
      id: 307,
      icon: <DealersIcon />,
      name: "InActive User Request",
      link: ROUTES.INACTIVE_USER_REQUEST,
      roles: [1, 9, 11],
      environment: [1, 2],
    },
    {
      id: 51,
      icon: <BuyersIcon />,
      name: t("sidebar.buyers"),
      link: ROUTES.STOCK_BUYERS,
      roles: [1, 9, 20],
      environment: [1, 2],
    },
    {
      id: 52,
      icon: <BuyersOrdersIcon />,
      name: t("sidebar.stockUserOrders"),
      link: ROUTES.STOCK_BUYER_ORDERS,
      roles: [1, 9, 20],
      environment: [1, 2],
    },
    {
      id: 53,
      icon: <MerchantsIcon />,
      name: t("sidebar.merchant"),
      link: ROUTES.STOCK_MERCHANTS,
      roles: [1, 9, 20],
      environment: [1, 2],
    },
    {
      id: 54,
      icon: <MerchantsOrdersIcons />,
      name: t("sidebar.stockMerchantOrders"),
      link: ROUTES.STOCK_MERCHANT_ORDERS,
      roles: [1, 9, 20],
      environment: [1, 2],
    },
    {
      id: 55,
      icon: <StockDailyCouriersIcon />,
      name: t("sidebar.stockDailyCouriers"),
      link: ROUTES.STOCK_DAILY_COURIERS,
      roles: [1, 9, 20],
      environment: [1, 2],
    },
    {
      id: 56,
      icon: <StockScrapTypesIcon />,
      name: "Track Courier Deficit",
      link: ROUTES.TRACK_COURIER_DEFICIT,
      roles: [1, 9],
      environment: [],
    },
    {
      id: 57,
      icon: <StockScrapTypesIcon />,
      name: t("sidebar.stockScrapTypes"),
      link: ROUTES.STOCK_SCRAP_TYPES,
      roles: [1, 9, 20],
      environment: [1, 2],
    },
    {
      id: 60,
      icon: <InitialsScrapBalanceIcon />,
      name: t("sidebar.initialScrapBalance"),
      link: ROUTES.INITIAL_SCRAP_BALANCE,
      roles: [1, 9, 20],
      environment: [1, 2],
    },
    {
      id: 61,
      icon: <StoresIcon />,
      name: t("sidebar.storeBalances"),
      link: ROUTES.STORE_BALANCES,
      roles: [20],
      environment: [1, 2],
    },
    {
      id: 4,
      icon: <MerchantSalesRequestsIcon />,
      name: "Merchant Sales Requests",
      link: ROUTES.MERCHANT_SALES_REQUESTS,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 5,
      icon: <SalesRequestsReturnsIcon />,
      name: "Sales Requests Returns",
      link: ROUTES.SALES_REQUESTS_RETURNS,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 6,
      icon: <MerchantPeriodsIcon />,
      name: "Merchant Periods",
      link: ROUTES.MERCHANT_PERIODS,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 7,
      icon: <MerchantScrapTypesIcon />,
      name: "Merchant Scrap Types",
      link: ROUTES.MERCHANT_SCRAP_TYPES,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 8,
      icon: <CourierReportIcon />,
      name: "Courier Report",
      link: ROUTES.COURIER_REPORT,
      roles: [1, 9, 11],
      environment: [1, 2],
    },
    {
      id: 15,
      icon: <CourierIcon />,
      name: "Couriers",
      link: ROUTES.COURIER,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 9,
      icon: <DailyCouriersIcon />,
      name: "Daily Couriers",
      link: ROUTES.DAILY_COURIES,
      roles: [1, 9, 10, 14],
      environment: [1, 2],
    },
    {
      id: 59,
      icon: <CourierTrackingIcon />,
      name: "Courier Tracking",
      link: ROUTES.COURIER_TRACKING,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 36,
      icon: <CourierDistrictsIcon />,
      name: "Courier Districts",
      link: ROUTES.COURIER_DISTRICTS,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 10,
      icon: <SocialOrdersIcon />,
      name: "Social Orders",
      link: ROUTES.SOCIAL_ORDERS,
      roles: [1, 9, 10, 12, 14, 15],
      environment: [1, 2],
    },
    {
      id: 65,
      icon: <SocialOrdersIcon />,
      name: "Social Orders UAE",
      link: ROUTES.SOCIAL_ORDERS_UAE,
      roles: [1, 9, 10, 12, 14, 15],
      environment: [1, 2],
    },
    {
      id: 11,
      icon: <RedeemPointsIcon />,
      name: "Redeem Points Requests",
      link: ROUTES.REDEEM_POINTS_REQUESTS,
      roles: [1, 9, 12, 15],
      environment: [1, 2],
    },
    {
      id: 66,
      icon: <RedeemPointsIcon />,
      name: "Redeem Points Requests UAE",
      link: ROUTES.REDEEM_POINTS_REQUESTS_UAE,
      roles: [1, 9, 12, 15],
      environment: [1, 2],
    },
    {
      id: 12,
      icon: <SupplyingTypesIcon />,
      name: "Supplying Types",
      link: ROUTES.SUPPLYING_TYPES,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 13,
      icon: <GovernmentIcon />,
      name: "Governments",
      link: ROUTES.GOVERNMENT,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 14,
      icon: <CityIcon />,
      name: "Areas",
      link: ROUTES.CTIY,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 61,
      icon: <CityIcon />,
      name: "Zones",
      link: ROUTES.ZONES,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 16,
      icon: <HomeBannerIcon />,
      name: "Home Banner",
      link: ROUTES.HOME_BANNER,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 17,
      icon: <StoresIcon />,
      name: "Stores",
      link: ROUTES.STORES,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 18,
      icon: <DoDontImageIcon />,
      name: "Do/Don't Images",
      link: ROUTES.DO_DONT_IMAGES,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 19,
      icon: <MarketplaceBannerIcon />,
      name: "Marketplace Banner",
      link: ROUTES.MARKETPLACE_BANNER,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 20,
      icon: <StoreCategoriesIcon />,
      name: "Marketplace Categories",
      link: ROUTES.STORE_CATEGORIES,
      roles: [1, 9, 22],
      environment: [1, 2],
    },
    {
      id: 21,
      icon: <StoreSubcategoriesIcon />,
      name: "Marketplace Subcategories",
      link: ROUTES.STORE_SUBCATEGORIES,
      roles: [1, 9, 22],
      environment: [1, 2],
    },
    {
      id: 22,
      icon: <StoreItemsIcon />,
      name: "Marketplace Products",
      link: ROUTES.STORE_PRODUCTS,
      roles: [1, 9, 22],
      environment: [1, 2],
    },
    {
      id: 23,
      icon: <PartnersIcon />,
      name: "Partners",
      link: ROUTES.PARTNERS,
      roles: [1, 9],
      environment: [1],
    },
    {
      id: 24,
      icon: <PartnershipIcon />,
      name: "Partnership",
      link: ROUTES.PARTNERSHIP,
      roles: [1, 9, 14, 24],
      environment: [1, 2],
    },
    {
      id: 25,
      icon: <NotificationIcon />,
      name: "Notifications",
      link: ROUTES.NOTIFICATION,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 26,
      icon: <ChatIcon />,
      name: "Big Scrappers Chat",
      link: ROUTES.CHAT_SCRAPPERS,
      roles: [1, 9, 15],
      environment: [1, 2],
    },
    {
      id: 27,
      icon: <ScrappersChatIcon />,
      name: "Green Scouts Chat",
      link: ROUTES.CHAT_SCOUTS,
      roles: [1, 9, 16],
      environment: [1, 2],
    },
    {
      id: 37,
      icon: <CommunityCategoriesIcon />,
      name: "Community Categories",
      link: ROUTES.COMMUNITY_CATEGORIES,
      roles: [1, 9, 17],
      environment: [1, 2],
      fillStrokesOnly: true,
    },
    {
      id: 38,
      icon: <CommunitySubCategoriesIcon />,
      name: "Community SubCategories",
      link: ROUTES.COMMUNITY_SUBCATEGORIES,
      roles: [1, 9, 17],
      environment: [1, 2],
      fillStrokesOnly: true,
    },
    {
      id: 50,
      icon: <PendingPostsIcon />,
      name: "Pending Posts",
      link: ROUTES.ALL_PENDING_POSTS,
      roles: [1, 9, 17],
      environment: [1, 2],
    },
    {
      id: 39,
      icon: <AcceptedPostsIcon />,
      name: "Accepted Posts",
      link: ROUTES.ACCEPTED_POSTS,
      roles: [1, 9, 17],
      environment: [1, 2],
    },
    {
      id: 49,
      icon: <RejectedPostsIcon />,
      name: "Rejected Posts",
      link: ROUTES.ALL_REJECTED_POSTS,
      roles: [1, 9, 17],
      environment: [1, 2],
    },
    {
      id: 41,
      icon: <AdminPostsIcon />,
      name: "Admin Posts",
      link: ROUTES.ADMIN_POSTS,
      roles: [1, 9, 17],
      environment: [1, 2],
    },
    {
      id: 58,
      icon: <PostsAttributesIcon />,
      name: "Posts Attributes",
      roles: [1, 9, 17],
      environment: [1, 2],
      type: "dropdown",
      list: [
        {
          id: 1,
          icon: <AttributeKeysIcon />,
          name: "Attributes Keys",
          link: ROUTES.ATTRIBUTES_KEYS,
        },
        {
          id: 2,
          icon: <LinkingAttributesIcon />,
          name: "Linking Attributes",
          link: ROUTES.LINKING_ATTRIBUTES,
        },
      ],
    },
    {
      id: 29,
      icon: <SettingsIcon />,
      name: "Settings",
      link: ROUTES.SETTINGS,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 62,
      icon: <RatesIcons />,
      name: "Rates",
      link: ROUTES.RATES,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 281,
      icon: <QuestionCategoryIcon />,
      name: "Questions Categories",
      link: ROUTES.QUESTIONS_CATEGORIES,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 63,
      icon: <CourierIcon />,
      name: "Courier Weights",
      link: ROUTES.COURIER_WEIGHTS,
      roles: [9, 10, 12, 14],
      environment: [1, 2],
    },
    {
      id: 291,
      icon: <QuestionIcon />,
      name: "Questions",
      link: ROUTES.QUESTIONS,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 292,
      icon: <MerchantBuyItemIcon />,
      name: "Merchant Buy Item",
      link: ROUTES.MERCHANT_BUY_ITEM,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 293,
      icon: <PendingMerchantIcon />,
      name: "Pending Merchant Buy Orders",
      link: ROUTES.PENDING_MERCHANT_BUY_ORDERS,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 294,
      icon: <MerchantBuyOrderIcon />,
      name: "All Merchant Buy Orders",
      link: ROUTES.ALL_MERCHANT_BUY_ORDERS,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 305,
      icon: <MerchantBuyOrderIcon />,
      name: "Suppliers",
      link: ROUTES.SUPPLIERS,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 295,
      icon: <ScraptionCompanyIcon />,
      name: "Scraption Company",
      link: ROUTES.SCRAPTION_COMPANY,
      roles: [1, 9],
      environment: [1, 2],
    },
    {
      id: 296,
      icon: <GulfCategory />,
      name: "Gulf Category",
      link: ROUTES.GULF_CATEGORIES,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 297,
      icon: <GulfSubCategory />,
      name: "Gulf SubCategories",
      link: ROUTES.GULF_SUBCATEGORIES,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 298,
      icon: <GulfProduct />,
      name: "Gulf Products",
      link: ROUTES.GULF_PRODUCTS,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 299,
      icon: <GulfGovernment />,
      name: "Gulf Goverment",
      link: ROUTES.GULF_GOVERMENT,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 300,
      icon: <GulfDistrict />,
      name: "Gulf District",
      link: ROUTES.GULF_DISTRICT,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 301,
      icon: <MerchantStore />,
      name: "Merchant Store Orders",
      link: ROUTES.MERCHANT_STORE_ORDERS,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 302,
      icon: <PendingCash />,
      name: "Pending Cash Request",
      link: ROUTES.PENDING_CASH_REQUEST,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 304,
      icon: <PendingCash />,
      name: "Withdrawls",
      link: ROUTES.WITHDRAWLS,
      roles: [1, 9, 23],
      environment: [1, 2],
    },
    {
      id: 303,
      icon: <PendingCash />,
      name: "Merchant National Id",
      link: ROUTES.MERCHANT_NATIONAL_ID,
      roles: [1, 9, 23],
      environment: [1, 2],
    },

    // // {
    // //   id: 42,
    // //   icon: <InstallmentPlansIcon />,
    // //   name: "Installment Plans",
    // //   link: ROUTES.INSTALLMENT_PLANS,
    // //   roles: [1, 9],
    // //   environment: [],
    // // },
    // // {
    // //   id: 43,
    // //   icon: <InstallmentRequestsIcon />,
    // //   name: "Installment Requests",
    // //   link: ROUTES.INSTALLMENT_REQUESTS,
    // //   roles: [19, 1, 9],
    // //   environment: [],
    // // },
    // // {
    // //   id: 44,
    // //   icon: <CustomerPaymentDuesIcon />,
    // //   name: "Customer's Payment Dues",
    // //   link: ROUTES.CUSTOMER_PAYMENT_DUES,
    // //   roles: [19, 1, 9],
    // //   environment: [],
    // // },
    // // {
    // //   id: 45,
    // //   icon: <InstalllmentPendingOrdersIcon />,
    // //   name: "Installment Pending Orders",
    // //   link: ROUTES.INSTALLMENT_PENDING_ORDERS,
    // //   roles: [19, 1, 9],
    // //   environment: [],
    // // },
    // // {
    // //   id: 46,
    // //   icon: <AdminPaymentDuesIcon />,
    // //   name: "Admin Payment Dues",
    // //   link: ROUTES.ADMIN_PAYMENT_DUES,
    // //   roles: [19, 1, 9],
    // //   environment: [],
    // // },
    // // {
    // //   id: 47,
    // //   icon: <InstallmentAcceptedOrdersIcon />,
    // //   name: "Installment Accepted Orders",
    // //   link: ROUTES.INSTALLMENT_ACCEPTED_ORDERS,
    // //   roles: [19, 1, 9],
    // //   environment: [],
    // // },
    // // {
    // //   id: 48,
    // //   icon: <InstallmentStatisticsIcon />,
    // //   name: "Installment Statistics",
    // //   link: ROUTES.INSTALLMENT_STATISTICS,
    // //   roles: [19, 1, 9],
    // //   environment: [],
    // // },

    // // {
    // //   id: 29,
    // //   icon: <TypesIcon />,
    // //   name: "Types",
    // //   link: ROUTES.CATEGORIES,
    // //   roles: [1, 7, 9],
    // //   environment: [],
    // // },
    // // {
    // //   id: 30,
    // //   icon: <SalesRequestsIcon />,
    // //   name: "Scrappers Sales Requests",
    // //   link: "scrappers-sales-requests",
    // //   roles: [1, 7, 9],
    // //   environment: [],
    // // },
    // // {
    // //   id: 31,
    // //   icon: <DealersChecksIcon />,
    // //   name: "Scrappers' Checks",
    // //   link: "scrappers-checks",
    // //   roles: [1, 9],
    // //   environment: [],
    // // },
    // // {
    // //   id: 32,
    // //   icon: <ScrappersSalesRequestsIcon />,
    // //   name: "Robabekia Sales Requests",
    // //   link: "robabekia-sales-requests",
    // //   roles: [1, 7, 9],
    // //   environment: [],
    // // },
    // // {
    // //   id: 33,
    // //   icon: <ItemsIcon />,
    // //   name: "Items",
    // //   link: "items",
    // //   roles: [1],
    // //   environment: [],
    // // },
    // // {
    // //   id: 34,
    // //   icon: <AllOrdersIcon />,
    // //   name: "All Orders",
    // //   link: "orders",
    // //   roles: [1],
    // //   environment: [],
    // // },
    // // {
    // //   id: 35,
    // //   icon: <PendingOrdersIcon />,
    // //   name: "Pending Orders",
    // //   link: "pending-orders",
    // //   roles: [1],
    // //   environment: [],
    // // },
  ];

  const isStockAdmin = adminRoles?.includes(20);

  // Filter tabs based on roles, environment, and search query
  const filteredTabs = tabsData
    .filter((tab) => {
      const adminAuthorized = adminRoles?.some((role) =>
        tab.roles.includes(role),
      );
      const tabAllowedInEnvironment =
        (environment === "test" && tab.environment.includes(1)) ||
        (environment === "live" && tab.environment.includes(2));
      return adminAuthorized && tabAllowedInEnvironment;
    })
    .filter((tab) => {
      if (!isStockAdmin || !forShop) return true;

      if (!selectedShop) {
        return tab.link === ROUTES.STORE_BALANCES;
      }

      return true;
    })
    .filter((tab) =>
      tab.name.toLowerCase().includes(searchQuery.toLowerCase()),
    );

  const handleTabClick = ({ link }) => {
    dispatch(updateCurrentPath(link));
    if (link !== "social-orders") {
      localStorage.setItem("currentPage", 1);
    }
  };

  const handleShopSelect = (shopId) => {
    dispatch(setShop(shopId));
    // setShowShopModal(false);
  };

  useEffect(() => {
    setActiveTab(location.pathname.slice(1));
  }, [location]);

  // useEffect(() => {
  //   if (adminRoles?.includes(1) || adminRoles?.includes(9)) {
  //     updateChatNotifications();
  //     updateChatNotifications(true);
  //   } else if (adminRoles?.includes(16)) {
  //     updateChatNotifications(true);
  //   } else if (adminRoles?.includes(15)) {
  //     updateChatNotifications();
  //   }
  // }, [adminRoles]);

  return (
    <div className="sidebar d-flex flex-column align-items-center align-items-md-stretch">
      <img
        src={logo}
        alt="Scraption logo"
        className="sidebar__logo d-block mx-auto img-fluid my-4"
      />
      <div className="sidebar__welcome-section d-flex flex-column flex-lg-row gap-2 justify-content-between align-items-center mb-4">
        <p className="d-flex flex-column align-items-center mb-0 text-center text-lg-start">
          <span className="fsize--10">{t("common.welcome")},</span>
          <span className="fsize--9 fw-bold">{authorization?.fullName}</span>
        </p>
        <Button
          type="button"
          onClick={handleLogout}
          className="sidebar__welcome-section__logout d-flex justify-content-center align-items-center border-0 bg-primary--3 outline-0"
        >
          <img src={logoutIcon} alt="Logout" className="d-flex img-fluid" />
        </Button>
      </div>

      {/* Search Input */}
      <div style={{ textAlign: "center", width: "100%", marginBottom: "1rem" }}>
        {isMobile ? (
          <>
            <SearchOutlined
              onClick={() => setIsSearchOpen(true)}
              style={{ fontSize: "22px", color: "#589559", fontWeight: "bold" }}
            />
            {isSearchOpen && (
              <Modal
                open={isMobile && isSearchOpen}
                // closable={false}
                footer={null}
                onCancel={() => setIsSearchOpen(false)}
              >
                <Input
                  style={{ marginTop: "2rem" }}
                  placeholder={t("common.search")}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  allowClear
                  autoFocus
                />
              </Modal>
            )}
          </>
        ) : (
          <div className="mb-3 w-100 px-3">
            <Input
              placeholder={t("common.search")}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              allowClear
            />
          </div>
        )}
      </div>

      {forShop && (
        <div className="mb-3 w-100 px-3">
          <label htmlFor="shops" className="mb-2 text--primary-1">
            {t("sidebar.selectShop")}
          </label>
          <Select
            id="shops"
            style={{ width: "100%" }}
            placeholder={t("sidebar.selectShop")}
            options={shopStores}
            onChange={handleShopSelect}
            value={selectedShop || undefined}
          />
        </div>
      )}
      {/* <div className="mb-3 w-100 px-3">
        <Input
          placeholder={t("common.search")}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          allowClear
        />
      </div> */}
      <ul className="sidebar__list list-unstyled mb-0 mx-2">
        {filteredTabs.map((tab) => (
          <li key={tab.id} className="w-100">
            <Tab
              item={tab}
              activeTab={activeTab}
              onClick={() => handleTabClick(tab)}
            />
          </li>
        ))}
        {/* {tabsData
          .filter((tab) => {
            const adminAuthorized = adminRoles?.some((role) =>
              tab.roles.includes(role)
            );
            const tabAllowedInEnvironment =
              (environment === "test" && tab.environment.includes(1)) ||
              (environment === "live" && tab.environment.includes(2));
            return adminAuthorized && tabAllowedInEnvironment;
          })
          .map((tab) => {
            return (
              <li key={tab.id} className="w-100">
                <Tab
                  item={tab}
                  activeTab={activeTab}
                  onClick={() => handleTabClick(tab)}
                />
              </li>
            );
          })} */}
      </ul>
    </div>
  );
};

export default SideBar;
